var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c('h2',[_vm._v("Work In Progress")]),_c('iframe',{staticClass:"giphy-embed",attrs:{"src":"https://giphy.com/embed/1XgIXQEzBu6ZWappVu","width":"480","height":"360","frameBorder":"0","allowFullScreen":""}})])
}]

export { render, staticRenderFns }